import React, { useState } from "react";

const faqData = [
  {
    question: "What does 'Available' mean?",
    answer:
      "Available items are currently in stock and ready for immediate purchase and delivery.",
  },
  {
    question: "What does 'Pre-Order' mean?",
    answer:
      "Pre-order items are not yet in stock. You can place your order and make payment in advance, and the item will be delivered after it arrives at CHAREX.",
  },
  {
    question: "How long do pre-order items take to arrive?",
    answer:
      "Pre-order items usually take about 2–3 months to arrive after they have been purchased and shipped. Customers will receive updates as the order progresses.",
  },
  {
    question: "What is a shipment fee, and why isn’t it added at first?",
    answer:
      "The shipment fee applies mainly to pre-ordered goods and may be added when the items are ready for delivery. It is not always included during the initial order because the final shipping cost may only be confirmed after the goods arrive. You can view and pay the shipment fee from your order dashboard when it becomes available.",
  },
  {
    question: "How long does delivery take?",
    answer:
      "Delivery for available items usually takes 2–5 working days, depending on your location. Pre-ordered items will be delivered after they arrive and the required shipment fee has been paid.",
  },
  {
    question: "Must I create an account before placing an order?",
    answer:
      "No. You can browse products, add items to your cart, and proceed to checkout. Your account can be created automatically from the information you provide during checkout, making it easier to track your orders and shop again.",
  },
  {
    question: "Can I track my order?",
    answer:
      "Yes. You can monitor your order status from your account dashboard. CHAREX may also send important order and delivery updates through email, phone, or WhatsApp.",
  },
  {
    question: "Do you import items directly from suppliers?",
    answer:
      "Yes. CHAREX sources and imports products from trusted suppliers and distributors to help ensure product quality and reliability.",
  },
  {
    question: "Can I get a refund after payment?",
    answer:
      "Refunds may be issued if an ordered item becomes unavailable or if CHAREX is unable to fulfil the order. Other refund requests will be reviewed based on the condition and status of the order.",
  },
  {
    question: "Do you deliver outside Nigeria?",
    answer:
      "Yes. CHAREX currently supports selected international deliveries, including the United Kingdom and Ghana. Delivery availability and charges may depend on the destination.",
  },
  {
    question: "How can I contact customer support?",
    answer: (
      <span>
        You can call or WhatsApp{" "}
        <a
          href="https://wa.me/2347064058684?text=Hello%20CHAREX%2C%20I%20would%20like%20to%20make%20an%20inquiry."
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold text-[#7b2cbf] hover:text-[#45a864] hover:underline"
        >
          +234 706 405 8684
        </a>{" "}
        or send an email to{" "}
        <a
          href="mailto: PreorderwithCharex@gmail.com"
          className="font-bold text-[#7b2cbf] hover:text-[#45a864] hover:underline"
        >
           PreorderwithCharex@gmail.com
        </a>
        .
      </span>
    ),
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex((currentIndex) =>
      currentIndex === index ? null : index
    );
  };

  return (
    <section
      id="faq"
      className=" text-gray-800 py-12 px-5 md:px-20"
    >
      <div className="w-full bg-gradient-to-br from-[#faf7ff] via-white to-[#f4fff7] rounded-2xl shadow-md p-6 md:p-10 lg:p-12">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 tracking-tight">
            Frequently Asked Questions
          </h2>

          <p className="text-sm text-gray-500 mt-3">
            Find answers to common questions about shopping with{" "}
            <span className="font-bold text-[#7b2cbf]">CHAREX</span>.
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className={`overflow-hidden rounded-xl border bg-white shadow-sm transition-all duration-300 ${
                  isOpen
                    ? "border-[#7b2cbf] ring-2 ring-[#45a864]/20 shadow-md"
                    : "border-gray-200 hover:border-[#7b2cbf]/50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggleAnswer(index)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${index}`}
                  className={`w-full text-left p-4 md:p-5 flex justify-between items-center gap-4 font-semibold transition-colors duration-300 ${
                    isOpen
                      ? "bg-[#f7f0ff] text-[#7b2cbf]"
                      : "text-gray-700 hover:bg-[#faf7ff]"
                  }`}
                >
                  <span>{item.question}</span>

                  <span
                    className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-xl font-bold transition-all duration-300 ${
                      isOpen
                        ? "bg-[#7b2cbf] text-white rotate-180"
                        : "bg-[#eef9f1] text-[#45a864]"
                    }`}
                  >
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                {isOpen && (
                  <div
                    id={`faq-answer-${index}`}
                    className="p-4 md:p-5 text-gray-600 leading-relaxed border-t border-[#7b2cbf]/10 bg-white"
                  >
                    {item.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;